

import React, { useContext } from 'react';
import { AccessibilityContext } from '../../App';

interface AccessibilityModalProps {
  onClose: () => void;
}

const AccessibilityModal: React.FC<AccessibilityModalProps> = ({ onClose }) => {
  const context = useContext(AccessibilityContext);

  if (!context) {
    return null; 
  }

  const { isHighContrast, setIsHighContrast, isDyslexicFont, setIsDyslexicFont, isVoiceOver, setIsVoiceOver } = context;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white p-6 rounded-lg shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">Accessibility Settings</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800 text-2xl font-bold">&times;</button>
        </div>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <label htmlFor="high-contrast" className="text-gray-700 mr-4">High-Contrast Mode</label>
            <button
              id="high-contrast"
              onClick={() => setIsHighContrast(prev => !prev)}
              className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors ${isHighContrast ? 'bg-blue-600' : 'bg-gray-200'}`}
            >
              <span className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${isHighContrast ? 'translate-x-6' : 'translate-x-1'}`} />
            </button>
          </div>
          <div className="flex items-center justify-between">
            <label htmlFor="dyslexic-font" className="text-gray-700 mr-4">Dyslexia-Friendly Font</label>
            <button
              id="dyslexic-font"
              onClick={() => setIsDyslexicFont(prev => !prev)}
              className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors ${isDyslexicFont ? 'bg-blue-600' : 'bg-gray-200'}`}
            >
              <span className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${isDyslexicFont ? 'translate-x-6' : 'translate-x-1'}`} />
            </button>
          </div>
           <div className="flex items-center justify-between">
            <label htmlFor="voice-over" className="text-gray-700 mr-4">Voice Over (Read Words)</label>
            <button
              id="voice-over"
              onClick={() => setIsVoiceOver(prev => !prev)}
              className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors ${isVoiceOver ? 'bg-blue-600' : 'bg-gray-200'}`}
            >
              <span className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${isVoiceOver ? 'translate-x-6' : 'translate-x-1'}`} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessibilityModal;